import React, { useEffect } from 'react';
import Pagination from './pagination';
import Range from './range';
import Slider from './slider';
import Carousel from './carousel';
const PAGINATION_MAP = new Map([
    ['pagination', Pagination],
    ['range', Range],
    ['slider', Slider],
    ['carousel', Carousel]
]);
export const PaginationComponent = ({ type = 'pagination', ...rest }) => {
    useEffect(() => {
        if (rest.currentPage > rest.totalPages) {
            throw new Error('Pagination fail');
        }
    }, [rest.totalPages, rest.currentPage]);
    const Pagination = PAGINATION_MAP.get(type);
    return React.createElement(Pagination, { key: type, ...rest });
};
